/**
 * On a cold start, code that branches on `hasNoMember` can run before the profile lands,
 * when it still reads false, and take the member path for a login that has none. Wait for
 * it first (fetchProfile shares the request already in the air); a failed load falls
 * through to the member path, as before.
 */

/** Whether the profile has loaded far enough to say member or waiting login. */
export const profileKnown = profile => Boolean(profile?.id) || profile?.hasNoMember === true;

/**
 * @param {object} profile the profile module's state
 * @param {Function} dispatch a Vuex dispatch (module or root)
 * @returns {Promise<void>} settles once the profile is known, or its load failed
 */
export const waitForProfile = (profile, dispatch) =>
  profileKnown(profile)
    ? Promise.resolve()
    : Promise.resolve(dispatch('profile/fetchProfile', null, { root: true })).catch(() => {});
